import DataTable, { createTheme } from "react-data-table-component";
import { useState,useEffect,useMemo,Fragment } from "react";

import DownloadIcon from '@mui/icons-material/Download';

import MoreVert from '@mui/icons-material/MoreVert';
import { ManageSearchRounded,Clear } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import {Modal,Box,Typography} from "@mui/material";

import {CircularProgress} from "@mui/material";

import { EneaButton,tablestyle,parseToLink } from "./Style";
import { TextField } from "@mui/material";
import { blue,blueGrey,green } from "@mui/material/colors";
import { ENEA_GEST_API_URL } from './Statics';


const baseurl= ENEA_GEST_API_URL;
//const baseurl = "https://dati.enea.it/gest/catalog/"

const basepagenum = "&per_page=999999";

//const allegatiurl = baseurl+"allegati/search?tag=Determina/Delibera%20di%20nomina%20del%20RUP%20e%20di%20indizione&per_page=10000";

const tableurl = baseurl+"allegati/search?"+basepagenum;

/*const taglists = [
  "&tag=Determina/Delibera di nomina del RUP e di indizione",
  "&tag=Determina/Delibera aggiudicazione atto equivalente&ref_obj=esiti",
  "&tag=Determina/Delibera aggiudicazione&ref_obj=esiti",
  "&tag=Determina/Delibera aggiudicazione atto equivalente&ref_obj=lotti",
];*/


const columns = [
  {
    name: <Typography variant="body2">Estremi documento</Typography>,
    selector: row => {
          return (
            <EneaButton href={parseToLink(row.link)} variant="contained" startIcon={<DownloadIcon />}>
              {row.nome_file}
            </EneaButton>
          );
      },
    sortable: false,
    width:"350px",
    wrap:true,
    },{
    name: <Typography variant="body2">Oggetto</Typography>,
    selector: row => row.oggetto_appalto,
    sortable: true,
    wrap:true,
    width:"500px",
  },
  {
    name: <Typography variant="body2">Procedura</Typography>,
    selector: row => row.procedura_nome,
    sortable: true,
    wrap:true,
    width:"250px",
  },
  ];
  
  const columns3 = [
    {
        name: <Typography variant="body2">Estremi documento</Typography>,
        selector: row => {
            return (
              <EneaButton href={parseToLink(row.link)} variant="contained" startIcon={<DownloadIcon />}>
                {row.nome_file}
              </EneaButton>
            );
        },
        grow:true,
        sortable: false,
        wrap:true,
        width:"350px",
      },
      {
        name: <Typography variant="body2">UO Richiedente</Typography>,
        selector: row => row.uo_richiedente,
        sortable: true,
        grow:true,
        wrap:true,
        width:"100px",
      },
      {
      name: <Typography variant="body2">Oggetto</Typography>,
      selector: row => row.oggetto_appalto,
      sortable: true,
      wrap:true,
      width:"400px",
    },
    {
      name: <Typography variant="body2">Procedura</Typography>,
      selector: row => row.procedura_nome,
      sortable: true,
      grow:true,
      wrap:true,
      width:"230px",
    },{
      name: <Typography variant="body2">Criterio</Typography>,
      selector: row => row.criterio_nome,
      sortable: true,
      grow:true,
      wrap:true,
      width:"180px",
    },
    ];

const definedAllegatiVals = [
  {query:"&tag=Determina/Delibera di nomina del RUP e di indizione",
    title:"Procedura di gara",
    colums:columns},
  {query:"&tag=Determina/Delibera aggiudicazione atto equivalente&ref_obj=esiti",
    title:"Affidamenti diretti",
    colums:columns},
  {query:"&tag=Determina/Delibera aggiudicazione&ref_obj=esiti",
    title:"Provvedimenti Finali con Aggiudicazione",
    colums:columns3},
  {query:"&tag=Determina/Delibera aggiudicazione atto equivalente&ref_obj=lotti",
    title:"Provvedimenti Finali senza Aggiudicazione",
    colums:columns3}
];

// da documento del 19/3/2025

// elenco allegati tabellare lista 1
//allegati/search?tag=Determina/Delibera di nomina del RUP e di indizione&page=${currentPage}&per_page=${recordsPerPage}&q=${searchQuery}

// elenco allegati tabellare lista 2
//allegati/search?tag=Determina/Delibera aggiudicazione atto equivalente&ref_obj=esiti&page=${currentPage}&per_page=${recordsPerPage}&q=${searchQuery}

// elenco allegati tabellare lista 3
// allegati/search?tag=Determina/Delibera aggiudicazione&ref_obj=esiti${searchParams}

// elenco allegati tabellare lista 4
// allegati/search?tag=Determina/Delibera aggiudicazione atto equivalente&ref_obj=lotti' + search_params



// https://react-data-table-component.netlify.app/?path=/story/custom-styles-compact-grid--compact-grid&globals=backgrounds.grid:!false

createTheme(
	'ENEA',
	{
		text: {
			primary: blue[900],
			secondary: blue[900],
		},
		background: {
			default: '#ffffff',
		},
		context: {
			background: blue[900],
			text: '#aaaaaa',
		},
		divider: {
			default: blue[200],
		},
		button: {
      default: blue[800],
			hover: 'rgba(0,0,0,.08)',
			focus: 'rgba(255,255,255,.12)',
			disabled: 'rgba(255, 255, 255, .34)',
		},
		sortFocus: {
			default: blue[800],
		},
	},
);




/*const columns = [{
    name: 'id',
    selector: row => row.id,
    sortable: true,
    width:"100px",
},
{
    name: 'tag',
    selector: row => row.tag,
    sortable: true,
    width:"300px",
},
{
    name: 'oggetto',
    selector: row => row.oggetto_appalto,
    sortable: true,
    width:"600px",
},
{
    name: 'identificativo',
    selector: row => row.identificativo,
    sortable: true,
    width:"240px",
},
{
    name: 'uo richiedente',
    selector: row => row.uo_richiedente,
    sortable: true,
    width:"100px",
},
{
    name: 'criterio',
    selector: row => row.criterio_nome,
    sortable: true,
    width:"400px",
},
{
    name: 'link',
    selector: row => {
        
        return (
          <EneaButton href={parseToLink(row.link)} variant="contained" startIcon={<DownloadIcon />}>
            {row.nome_file}
          </EneaButton>
        );
    },
    sortable: false,
    width:"400px",
},

]*/

const TableAllegati =({listnum,mindate,maxdate})=>{

    const [json,setJson]=useState([]);
    const [busy,setBusy]=useState(false);
    const [page,setPage]=useState(0);
    const [filterText,setFilterText]=useState('');
    const [find,setFind]=useState([]);

    useEffect(()=>{
      console.log("search on allegati "+filterText);
      
    },[filterText])
    
    const subHeaderComponentMemo = () => {

      const handleClear = () => {
        setFilterText("");
      };
      const handleChange = (val) => {
        setFilterText(val);
      };

      return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ManageSearchRounded sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
            <TextField fullWidth 
              size="small" 
              variant='outlined' 
              value={filterText} 
              label="Ricerca full-text" 
              onChange={(e)=>handleChange(e.target.value)}/>
            <IconButton alt="clear filter" aria-label="clear filter" aria-valuetext="clear filter" sx={{color:blue[800]}} onClick={()=>handleClear()}>
              <Clear/>
           </IconButton>
        </Box>
        );
    };

     /* filter effect */
    useEffect(()=>{
    //let rex = filterText.trim().replace(" ",".+");
    if(filterText.length>0){
      let regex = new RegExp(filterText.trim().replaceAll(" ",".+"), "i");
      const find = json.filter( singlerow => {
        return Object.values(singlerow).filter( v => {
          if(typeof v === 'string' || v instanceof String)  
            return v.match(regex)!==null;
          return false;
        }).length>0
      }).map( o =>o);
      setFind(find);
    }else{
      setFind(json);
    }
    },[json,filterText]);

    const myfetch = (url,page,arraydest,cb)=>{
        let turl = url;
        if((page!==undefined)&&(page!==0)){
          turl+="&page="+page;
        }
        setBusy(true);
        fetch(turl,{
          method:'GET'
        }).then(resp=>resp.json())
        .then(j=>{
          arraydest.push(j.data);
          if(j.current_page<j.last_page){
            myfetch(url,j.current_page+1,arraydest,cb);
            setPage(j.current_page+1);
          } else {

             /* filter by min/max date if present */
            let filterdata = [];
            let tmpdata = [];
            
            if(mindate!==undefined){
              tmpdata = (arraydest.flatMap(o=>o).filter(f=>new Date(f.dt_allegato)>=new Date(mindate)));
            } else {
              tmpdata = (arraydest.flatMap(o=>o));
            }
            if(maxdate!==undefined){
              filterdata = (tmpdata.filter(fm=>new Date(fm.dt_allegato)<=new Date(maxdate)));
            }else{
              filterdata = (tmpdata);
            }

            setJson(filterdata);

            //setJson(arraydest.flatMap(o=>o));
            setBusy(false);
            cb(j);
          }
        }).catch(err=>{console.log("err")})
      };
      
      const selectedcolumns = ()=>{
        if(typeof listnum === 'number'){
          return definedAllegatiVals[listnum-1].colums;
        }
      }
      const selectedTitle = ()=>{
        if(typeof listnum === 'number'){
          return definedAllegatiVals[listnum-1].title;
        }
      }
      useEffect(()=>{
        if(typeof listnum === 'number'){
          let shl = listnum-1;
          if((shl<definedAllegatiVals.length)&&(shl>-1)){
            
            myfetch(tableurl+encodeURI(definedAllegatiVals[shl].query),0,[],()=>console.log("Tabella allegati "+definedAllegatiVals[shl].title+" finish"));
            return;
          }
        } 
        console.log("Numero lista non valido. Inserisci attributo 'listnum' valido sul componente.");
        
      },[]);

    return (
    <Fragment role="main">
    <DataTable 
      customStyles={tablestyle} 
      highlightOnHover 
      subHeader 
      subHeaderComponent={subHeaderComponentMemo()} 
      persistTableHead 
      theme="ENEA" 
      progressPending={busy} 
      progressComponent={
        <p><CircularProgress/></p>
      } 
      ariaLabel={selectedTitle()} 
      columns={selectedcolumns()} 
      data={find} 
      paginationComponentOptions={{
        rowsPerPageText:"Righe per pagina",
      }}
      pagination />
    </Fragment>
      );
}

export {TableAllegati,definedAllegatiVals};